import React from 'react';

import ReportListGuesser from './ReportListGuesser';

const ReportDataList = props => (
  <ReportListGuesser {...props} bulkActionButtons={null} exporter={false} actions={null} />
);

export default ReportDataList;
